import React from 'react';
import MenuAppBar from '../components/MenuAppBar'

const ErrorPage404 = () => {
    return(
        <div>
            <MenuAppBar pageTitle="OPPS ! ERROR"/>
            <h1>404 PAGE NOT FOUND ! </h1>
            <p>Created by Sahil</p>
        </div>
        
    );
}

export default ErrorPage404;